import { ComponentType } from "react";
import dynamic from "next/dynamic";
import { PromoContentProps } from "providers/CampaignProvider";
import { PromoContentType } from "api/cms-website/cms-promo-campaigns.types";

export const getPromoContentComponent = (
    content: PromoContentProps,
    type: "topBanner" | "priceBanner"
): (() => ComponentType<any>) | null => {
    switch (type) {
        case "topBanner":
            switch (content.__contentType) {
                case PromoContentType.RUNNING_LINE:
                    return () =>
                        dynamic(
                            () =>
                                import(
                                    "components/PromoCampaigns/promoContent/RunningLine/topBanner/RunningLine"
                                ),
                            {
                                ssr: false,
                            }
                        );
                default:
                    return null;
            }
        case "priceBanner":
            switch (content.__contentType) {
                case PromoContentType.RUNNING_LINE:
                    return () =>
                        dynamic(
                            () =>
                                import(
                                    "components/PromoCampaigns/promoContent/RunningLine/priceBanner/RunningLine"
                                ),
                            {
                                ssr: false,
                            }
                        );
                default:
                    return null;
            }
        default:
            return null;
    }
};
